"use client";

import React from "react";
import { BlurFade } from "@/components/ui/blur-fade";
import { Card, CardContent } from "@/components/ui/card";
import { Quote } from "lucide-react";

interface PressQuote {
  quote: string;
  source: string;
  rating?: string;
}

interface PressQuotesProps {
  title?: string;
  quotes: PressQuote[];
}

const PressQuotes = ({ title, quotes }: PressQuotesProps) => {
  if (!quotes || quotes.length === 0) return null;

  return (
    <section className="py-24 px-6 bg-white">
      <div className="container max-w-5xl mx-auto">
        {title && (
          <div className="text-center mb-16">
            <BlurFade delay={0.1}>
              <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
                {title}
              </h2>
            </BlurFade>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {quotes.map((item, i) => (
            <BlurFade key={i} delay={0.15 + i * 0.05}>
              <Card className="border-foreground/5 bg-muted/30 hover:bg-muted/50 transition-colors h-full">
                <CardContent className="p-8 space-y-5 flex flex-col h-full">
                  <Quote size={28} className="text-foreground/15 flex-shrink-0" strokeWidth={1.5} />
                  <p className="text-foreground/80 text-base leading-relaxed italic flex-1">
                    &ldquo;{item.quote}&rdquo;
                  </p>
                  <div className="flex items-center justify-between pt-2 border-t border-foreground/5">
                    <span className="text-sm font-bold text-foreground/60 uppercase tracking-wider">
                      {item.source}
                    </span>
                    {item.rating && (
                      <span className="text-sm font-semibold text-foreground/50">
                        {item.rating}
                      </span>
                    )}
                  </div>
                </CardContent>
              </Card>
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PressQuotes;
